var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-wizard-form" }, [
    _c(
      "div",
      { staticClass: "automation-wizard-form__step" },
      [
        _vm.currentStep.title
          ? _c("Heading", {
              staticClass: "automation-wizard-form__heading",
              attrs: {
                labelTitle: _vm.currentStep.title,
                variant: "h3",
                prefixColoredIcon: _vm.stepColoredIcon
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep.information
          ? _c("CompassAlert", {
              staticClass: "automation-wizard-form__information",
              attrs: {
                type: "neutral",
                description: _vm.currentStep.information,
                showClose: false
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "automation-wizard-form__field-group" },
          _vm._l(_vm.visibleFields, function(field, index) {
            return _c("AutomationWizardFormField", {
              key: index,
              attrs: {
                field: field,
                value: _vm.getFieldValue(field.id),
                formData: _vm.formData
              },
              on: {
                "update:value": function($event) {
                  return _vm.updateFieldValue(field.id, $event)
                }
              }
            })
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }